import { Hr } from '@dnb/eufemia/elements'
import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import differenceInDays from 'date-fns/differenceInDays';

import Card from '@dnb/eufemia/components/card/Card';

import GroupListItem from './GroupListItem';
import IconHeader from '../layout/IconHeader';

import './group.css';

import compareDesc from 'date-fns/compareDesc';

const Group = ({ item }) => {
  const { t, i18n } = useTranslation();
  const daysSinceIncidentNumber = () => {
    if (item.incidents.length === 0) return '00';
    else {
      let sorted = item.incidents.sort((a, b) => {
        return compareDesc(new Date(a.started_at), new Date(b.started_at));
      });
      let days = differenceInDays(new Date(), new Date(sorted[0].started_at));

      /*if (days < 10) return `0${days}`;*/
      return days.toString();
    }
  };

  const daysSinceIncidentText = () => {
    if (item.incidents.length === 0) {
      return (
        <>
          {t('No incidents in')} {t('over')} 3 {t('months')}
        </>
      );
    } else {
      return (
        <>
         {daysSinceIncidentNumber()} {t('days since')} {t('last')} {t('incident')}
        </>
      );
    }
  };

  /*return (
    <article className='dnb-group'>
      <IconHeader name={t(item.name)} icon={item.name} />
      <div className='dnb-group-content'>
        <div className='dnb-group-content__left'>
          <div className='dnb-incident-counter'>
            <span className='dnb-incident-counter__number'>{daysSinceIncidentNumber()}</span>
            <span className='dnb-incident-counter__text'>{daysSinceIncidentText()}</span>
          </div>
        </div>
        <div className='dnb-group-content__right'>
          <div className='dnb-status-list'>
            <ul>
              {item.subComponents.map((el) => {
                return <GroupListItem item={el} key={el.id} />;
              })}
            </ul>
          </div>
        </div>
      </div>
    </article>
  );
};*/

  return (
    <Card className='dnb-group' innerSpace={false} align="stretch" outlineWidth={1.5} radius="1.5rem">
      <IconHeader name={t(item.name)} icon={item.name} />
      <div className='dnb-incident-counter'>
        <span className='dnb-incident-counter__text'>{daysSinceIncidentText()}</span>
      </div>
      <Hr />

      <div className='dnb-group-content'>
        <div className='dnb-group-content__left'>
          <div className='dnb-status-list'>
            <ul>
              {item.subComponents.map((el) => {
                return <GroupListItem item={el} key={el.id} />;
              })}
            </ul>
          </div>
        </div>
        <div className='dnb-group-content__right'>

        </div>
      </div>

    </Card>
  );
};


Group.propTypes =
{
  item: PropTypes.object,
  name
    :
    PropTypes.string,
}
  ;

export default Group;
